var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVziconUnitType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.45.46H3.55C1.85.46.46,1.85.46,3.55v8.9c0,1.7,1.39,3.09,3.09,3.09h8.9c1.7,0,3.09-1.39,3.09-3.09V3.55c0-1.7-1.39-3.09-3.09-3.09ZM9.57,13.69v-1.71c.25.06.52.14.79.27.69.32,1.12.79,1.32,1.44h-2.12ZM13.69,6.45h-3.29v1.85h3.29v4.14c0,.26-.08.5-.22.7-.2-.65-.53-1.22-1.01-1.69-1.47-1.46-3.72-1.45-3.82-1.45h-.92v3.68H3.55c-.68,0-1.24-.55-1.24-1.24v-4.14h5.65v-2.49h-1.85v.63h-3.8v-2.91c0-.68.55-1.24,1.24-1.24h2.56v1.64h1.85v-1.64h4.48c.68,0,1.24.55,1.24,1.24v2.91Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVziconUnitType);
export default __webpack_public_path__ + "static/media/vzicon_unit_type.495e4425.svg";
export { ForwardRef as ReactComponent };